(() => {
  const quiz = document.querySelector('[data-fragrance-finder]');
  if (quiz) {
    quiz.addEventListener('submit', (event) => {
      event.preventDefault();
      const data = new FormData(quiz);
      const terms = [data.get('audience'), data.get('family'), data.get('occasion'), data.get('strength')]
        .filter(Boolean);
      const query = terms.join(' ');
      const result = quiz.querySelector('[data-finder-result]');
      const link = quiz.querySelector('[data-finder-link]');
      link.href = `${window.routes?.search_url || '/search'}?type=product&q=${encodeURIComponent(query)}`;
      link.textContent = `View ${terms.join(' · ')} fragrances`;
      result.hidden = false;
      link.focus();
    });
  }

  const guardedForms = document.querySelectorAll('form.hdt-main-product-form');
  guardedForms.forEach((form) => {
    form.addEventListener('submit', async () => {
      const id = Number(new FormData(form).get('id'));
      if (!id || form.dataset.alSultanChecking === 'true') return;
      form.dataset.alSultanChecking = 'true';
      let before = 0;
      try {
        const cart = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`).then((response) => response.json());
        before = (cart.items || []).filter((item) => item.variant_id === id).reduce((sum, item) => sum + item.quantity, 0);
      } catch (_) {}
      window.setTimeout(async () => {
        try {
          const current = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`).then((response) => response.json());
          const after = (current.items || []).filter((item) => item.variant_id === id).reduce((sum, item) => sum + item.quantity, 0);
          if (after <= before) {
            const payload = new FormData(form);
            const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
              method: 'POST',
              headers: { Accept: 'application/json' },
              body: payload
            });
            if (response.ok) window.location.assign(`${window.Shopify?.routes?.root || '/'}cart`);
          }
        } catch (_) {
          form.dataset.alSultanChecking = 'false';
        }
      }, 2500);
    }, { passive: true });
  });
})();
